import { PublicHeader } from "@/components/public-header";
import { PublicFooter } from "@/components/public-footer";
import { FeatureBlocks, PageHero } from "@/components/marketing/sections";
import { StartFreeButton } from "@/components/marketing/cta";
import { useSEO } from "@/hooks/use-seo";
import { seoFor } from "@/data/marketing-routes";
import { RESEARCH_PAGE as R } from "@/data/core-pages";

/** Free research tools (build F6, Appendix A8). */
export default function ResearchLandingPage() {
  useSEO(seoFor("/research"));

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <PublicHeader />
      <PageHero title={R.h1} sub={R.sub} ctaLocation="research" showButtons={false}>
        <div className="mt-8 flex justify-center">
          <StartFreeButton
            ctaId="research-start"
            location="research"
            label="Start free research"
            signupParams={{ role: "researcher" }}
            className="px-8"
          />
        </div>
      </PageHero>

      <main className="flex-grow">
        <section className="bg-gray-50 px-4 py-14 md:py-20">
          <FeatureBlocks blocks={R.blocks} />
        </section>
      </main>

      <PublicFooter />
    </div>
  );
}
